/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { AllOption } from '@core/models';
import { createReducer, on } from '@ngrx/store';

// Lib
import { Client, ClientStatusEnum } from '@truckstop-tms/zuum-lib';
// Store
import { ClientDetailActions } from '@client-details/store/actions';
import { ClientListActions } from '..';
import { ClientDetailsDashboardActions } from '@client-details/store/actions';

export const CLIENT_LIST_FEATURE_KEY = 'client-list';

export interface ClientsTmsState {
  clients: Client[];
  totalNumberOfClients: number;
  statusFilter: (ClientStatusEnum | AllOption.All)[];
}

export const initialState: ClientsTmsState = {
  clients: null as any,
  totalNumberOfClients: 0,
  statusFilter: [],
};

export const clientListReducer = createReducer(
  initialState,

  on(ClientListActions.loadClientsSuccess, (state, { clients, totalNumberOfClients }) => ({
    ...state,
    clients,
    totalNumberOfClients,
  })),

  on(ClientListActions.updateClientStatusSuccess, ClientListActions.cancelClientPlanSuccess, (state, { client }) => ({
    ...state,
    clients:
      !state.statusFilter ||
      state.statusFilter.length === 0 ||
      state.statusFilter.some((status) => status === client.status)
        ? state.clients?.map((c) => (client.id === c.id ? { ...c, ...client } : c))
        : state.clients?.filter((c) => c.id !== client.id),
  })),

  on(ClientDetailActions.updateClientStatusFailure, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),

  on(ClientDetailsDashboardActions.deleteClientSuccess, (state, { clientId }) => ({
    ...state,
    clients: (state.clients || []).filter((c) => c.id !== clientId),
  })),

  on(ClientListActions.setStatusFilters, (state, { statusFilter }) => ({
    ...state,
    statusFilter,
  }))
);
